<template>
<div>
    <!-- <button v-on:click="save()" type="button" class="btn btn-primary">追加</button> -->
    <b-btn @click="visible = !visible" variant="primary" block>追加</b-btn>
    <b-modal 
        id="modal1" 
        size="xl"
        ok-title="閉じる" ok-only
        v-model="visible"
        title="作業内容選択">
        <b-card no-body class="mb-1" v-for="activity in activities" :key="activity.id">
            <b-card-header>
                <a href="#" class="text-primary" v-b-toggle="'acc'+activity.id">{{ activity.description }}</a>
            </b-card-header>
            <b-collapse accordion="activities" :id="'acc'+activity.id" role="tabpanel">
            <b-card-body>
                <b-row>
                    <b-col cols="4" class="mb-2" v-for="workContent in activity.work_contents" :key="workContent.id">
                        <b-button block variant="outline-primary" @click="selectWorkContent(workContent, activity)">{{ workContent.description }}</b-button>
                    </b-col>
                </b-row>
            </b-card-body>
            </b-collapse>
        </b-card>
    </b-modal>
</div>
</template>

<script>
    export default {
        mounted() {
            window.axios.get('/api/activities/').then(({data}) => {
                this.activities = data.activities
            });
        },
        data: function() {
            return {
                activities: {},
                visible: false
            }
        },
        methods: {
            save() {
                this.$emit('data-saved')
            },
            selectWorkContent(workContent, activity) {
                var nippouItem = workContent
                nippouItem.time = 0
                nippouItem.activity = {
                    id: activity.id,
                    description: activity.description
                }
                this.visible = !this.visible
                this.$emit('workcontent-selected', nippouItem)
            }
        }
    }
</script>
